import i18next from 'i18next';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useLanguageUtm = () => {
  const history = useHistory();

  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('utm_content')) {
      url.searchParams.append('utm_content', i18next.language);
      history.push(`${url.pathname}${url.search}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18next.language]);
};
